import { List } from 'immutable';
import BaseList from 'records/BaseList';

import {
  PREV_MENU_ANALYSIS_ACTION_START,
  PREV_MENU_ANALYSIS_ACTION_ERROR,
  PREV_MENU_ANALYSIS_CLONE_SUCCESS,
  PREV_MENU_ANALYSIS_UPDATE_VALUE_SUCCESS,
  PREV_MENU_ITEMS_ANALYSIS_UPDATE_VALUE_SUCCESS,
  PREV_MENU_CATEGORIES_ANALYSIS_UPDATE_VALUE_SUCCESS,
  PREV_MENU_ANALYSIS_RESET_STATE,
} from 'actions/prevMenuAnalysis';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [PREV_MENU_ANALYSIS_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [PREV_MENU_ANALYSIS_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [PREV_MENU_ANALYSIS_CLONE_SUCCESS]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: null,
      data: action.data,
    });
  },
  [PREV_MENU_ANALYSIS_UPDATE_VALUE_SUCCESS]: (state, action) => {
    const newMenuAnalysis = state.get('data').updateMenuAnalysisValue(action.key, action.value);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newMenuAnalysis,
    });
  },
  [PREV_MENU_ITEMS_ANALYSIS_UPDATE_VALUE_SUCCESS]: (state, action) => {
    let newMenuAnalysis = state.get('data').updateMenuItemsAnalysisValue(action.categoryId, action.menuItemId, action.key, action.value);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newMenuAnalysis,
    });
  },
  [PREV_MENU_CATEGORIES_ANALYSIS_UPDATE_VALUE_SUCCESS]: (state, action) => {
    let newMenuAnalysis = state.get('data').updateMenuCategoriesAnalysisValue(action.categoryId, action.key, action.value);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: newMenuAnalysis,
    });
  },
  [PREV_MENU_ANALYSIS_RESET_STATE]: () => {
    return initialState;
  },
};

export default function prevMenuAnalysis(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
